module.exports = __webpack_public_path__ + "img/31.cddc844b.jpeg";